export const LOCAL_STORAGE_SERVICE = "LocalStorageService";
